import {
  GET_EXERCISE,
  CREATE_EXERCISE,
  UPDATE_EXERCISE,
  DELETE_EXERCISE,
} from "../actions/types";

const initialState = {
  exerciseList: [],
  hospitalID: null,
  exerciseSaveStatus: null,
  exerciseUpdateStatus: null,
  exerciseDeleteStatus: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EXERCISE:
      return {
        ...state,
        exerciseList: action.payload.data,
        hospitalID: action.hospitalID, // Action se aayi hui Hospital ID store ho rahi hai
      };

    case CREATE_EXERCISE:
      return {
        ...state,
        exerciseSaveStatus: action.payload.success,
      };

    case UPDATE_EXERCISE:
      return {
        ...state,
        exerciseUpdateStatus: action.payload.success,
      };

    case DELETE_EXERCISE:
      return {
        ...state,
        exerciseDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}